import LegalPage from './LegalPage';

const DisclaimerPage = () => (
  <LegalPage
    slug="data-disclaimer"
    canonical="/disclaimer"
    fallbackTitle="Data Disclaimer"
    fallbackDescription="How UniXperts sources cost, ranking and university data."
  />
);

export default DisclaimerPage;
